import React, { FC } from 'react'
import { Group, Pagination } from '@mantine/core'

type Props = {
  page: number
  pageSize: number
  totalCount: number
  onChange: (page: number) => void
  className?: string
}

const Footer: FC<Props> = (props) => {
  const { page, pageSize, totalCount, onChange, className } = props
  const total = Math.ceil(totalCount / pageSize)
  if (total <= 1) {
    return null
  }
  return (
    <Group position="center" className={className} pb="md">
      <Pagination size="sm" value={page} onChange={onChange} total={total} />
    </Group>
  )
}

export default Footer
